import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  AfterViewInit,
  input,
  InputSignal,
  inject,
  effect,
} from '@angular/core';
import { TsColorUtils } from 'tsui/utils/ts-color.utils';

@Directive({
  selector: 'quill-editor[quillEditorConditionalStyling]',
})
export class QuillEditorStylingDirective implements AfterViewInit {
  readonly quillEditorConditionalStyling: InputSignal<string> = input.required();
  readonly blurContent: InputSignal<boolean> = input<boolean>(false);
  readonly elementRef = inject(ElementRef);
  readonly renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.applyStyling();
    }, 500);
  }

  private applyStyling(): void {
    const quillEditorTextInputArea = this.elementRef.nativeElement.querySelector('.ql-container .ql-editor');

    if (!quillEditorTextInputArea) {
      return;
    }

    this.renderer.setStyle(quillEditorTextInputArea, 'background-color', this.quillEditorConditionalStyling());
    this.renderer.setStyle(
      quillEditorTextInputArea,
      'color',
      TsColorUtils.isContrastLight(this.quillEditorConditionalStyling()) ? '#FFFFFF' : 'inherit',
    );

    if (this.blurContent()) {
      this.renderer.setStyle(quillEditorTextInputArea, 'filter', 'blur(3px)');
      this.renderer.setStyle(quillEditorTextInputArea, 'font-style', 'italic');
      this.renderer.setStyle(quillEditorTextInputArea, 'letter-spacing', '2px');
      this.renderer.setStyle(quillEditorTextInputArea, 'text-wrap', 'nowrap');
      this.renderer.setStyle(quillEditorTextInputArea, 'pointer-events', 'none');
    } else {
      this.renderer.removeStyle(quillEditorTextInputArea, 'filter');
      this.renderer.removeStyle(quillEditorTextInputArea, 'font-style');
      this.renderer.removeStyle(quillEditorTextInputArea, 'letter-spacing');
      this.renderer.removeStyle(quillEditorTextInputArea, 'text-wrap');
      this.renderer.removeStyle(quillEditorTextInputArea, 'pointer-events');
    }
  }
}
